import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Input, Result, Space, Typography, message } from 'antd';
import { getPublicNoticeLetterTokenByCode } from '../../services/debt';
import './NoticeLetterCodePage.css';

const { Text } = Typography;

const normalizeCode = (v) => String(v || '').replace(/\D/g, '').slice(0, 8);

const NoticeLetterCodePage = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const valid = useMemo(() => /^\d{8}$/.test(code), [code]);

  const submit = async () => {
    const c = normalizeCode(code);
    setCode(c);
    if (!/^\d{8}$/.test(c)) {
      message.error('请输入8位函件代码');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { data } = await getPublicNoticeLetterTokenByCode(c);
      const token = data?.token || '';
      if (!token) {
        setError('函件代码无效或已过期');
        return;
      }
      navigate(`/share/notice-letter/${token}`);
    } catch (e) {
      setError(e?.message || '函件代码无效或已过期');
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <div className="page-container p-share-notice-code">
        <div className="page-content">
          <Result
            status="error"
            title="无法打开催告函"
            subTitle={error}
            extra={[
              <Button key="back" onClick={() => setError('')}>返回输入</Button>,
            ]}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="page-container p-share-notice-code">
      <div className="page-content space-y-md">
        <div className="page-title">输入函件代码</div>
        <Card className="card-compact">
          <Space direction="vertical" className="p-share-notice-code-form" size={12}>
            <Text type="secondary">请输入短信中的8位函件代码以查看催告函详情</Text>
            <Input
              value={code}
              placeholder="8位数字"
              maxLength={8}
              inputMode="numeric"
              onChange={(e) => setCode(normalizeCode(e.target.value))}
              onPressEnter={submit}
              disabled={loading}
            />
            <Button type="primary" onClick={submit} loading={loading} disabled={!valid}>
              查看详情
            </Button>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default NoticeLetterCodePage;
